
export default function AboutSection() {
  const stats = [
    { number: '500+', label: 'Successful Projects' },
    { number: '15+', label: 'Years of Experience' },
    { number: '200+', label: 'Happy Clients' },
    { number: '50+', label: 'Expert Consultants' }
  ];

  const certifications = [
    { name: 'AWS Certified Solutions Architect', icon: 'ri-cloud-line' },
    { name: 'Microsoft Azure Expert', icon: 'ri-microsoft-line' },
    { name: 'Google Cloud Professional', icon: 'ri-google-line' },
    { name: 'Cisco Network Professional', icon: 'ri-router-line' },
    { name: 'CompTIA Security+', icon: 'ri-shield-check-line' },
    { name: 'ITIL Foundation', icon: 'ri-settings-3-line' }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Why Choose Shangalo Digital?
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              With over 15 years of experience in IT consulting, we've helped hundreds of businesses transform their technology infrastructure and achieve their digital goals. Our team of certified experts brings deep industry knowledge and proven methodologies to every project.
            </p>
            
            <div className="space-y-6 mb-8">
              <div className="flex items-start">
                <div className="w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center mr-4 mt-1">
                  <i className="ri-award-line text-emerald-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Industry Expertise</h3>
                  <p className="text-gray-600">Deep knowledge across multiple industries including healthcare, finance, manufacturing, and retail.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center mr-4 mt-1">
                  <i className="ri-team-line text-emerald-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Certified Professionals</h3>
                  <p className="text-gray-600">Our team holds industry-leading certifications from AWS, Microsoft, Google, Cisco, and more.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center mr-4 mt-1">
                  <i className="ri-customer-service-2-line text-emerald-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">24/7 Support</h3>
                  <p className="text-gray-600">Round-the-clock support to ensure your systems run smoothly and efficiently.</p>
                </div>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center p-4 bg-gray-50 rounded-lg">
                  <div className="text-2xl font-bold text-emerald-600">{stat.number}</div>
                  <div className="text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/4640c9aba784e69f7abc6bc1e52fbd4b.jpg"
              alt="Our Expert Team"
              className="rounded-2xl shadow-xl object-cover w-full h-[400px] object-top mb-8"
            />
            
            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Certifications</h3>
              <div className="grid grid-cols-2 gap-4">
                {certifications.map((cert, index) => (
                  <div key={index} className="flex items-center">
                    <div className="w-6 h-6 flex items-center justify-center mr-3">
                      <i className={`${cert.icon} text-emerald-600`}></i>
                    </div>
                    <span className="text-sm text-gray-700">{cert.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
